import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

// Single registration point for the GSAP plugins used by the Credenciales
// landing. Import `gsap`/`ScrollTrigger` from here (Phase 2 animations) so
// registerPlugin runs exactly once.
gsap.registerPlugin(ScrollTrigger)

export { gsap, ScrollTrigger }
